/**
 * Glassmorphism Component Library
 *
 * Y2K Revival + Glassmorphism design system for DramaDetector Layer 1.
 *
 * Components:
 * - GlassBackground: Aurora gradient with frosted overlay (screen backgrounds)
 * - GlassCard: Frosted glass cards with chrome borders (content containers)
 * - GlassPill: Bubble text headers with gradient pills (section headers)
 * - GlassButton: Gel buttons with glass highlight (interactive actions)
 *
 * Design Principles:
 * - Y2K iridescent gradients (Pink → Lavender → Mint → Teal)
 * - Chrome metallic accents (silver gradients)
 * - Glassmorphic blur effects (expo-blur)
 * - WCAG AA accessibility compliance
 * - Reduced transparency support (iOS/Android)
 *
 * @see apps/mobile/components/glass/README.md
 */

export { GlassBackground } from './GlassBackground';
export { GlassCard } from './GlassCard';
export { GlassPill } from './GlassPill';
export { GlassButton, type GlassButtonVariant } from './GlassButton';
